import { useEffect, useRef, useState } from "react";

export interface UseOnlineStatus {
  online: boolean;
  wasOffline: boolean;
}

export function useOnlineStatus(): UseOnlineStatus {
  const [online, setOnline] = useState<boolean>(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );
  const [wasOffline, setWasOffline] = useState(false);
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    const onOnline = () => {
      setOnline(true);
      setWasOffline(wasOfflineRef.current);
    };
    const onOffline = () => {
      setOnline(false);
      wasOfflineRef.current = true;
    };
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  return { online, wasOffline };
}